import React from "react";
import ProfileBanner from "../../shared/utilities/ProfileBanner";

const formatPhone = (phoneNo) => {
  let s2 = ("" + phoneNo).replace(/\D/g, "");
  var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
  return !m ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
}

const TransporterContact = props => {
  const { contactDetails } = props;
  return (
    <div> 
      <ProfileBanner title="Contact">
        <div>Name: {contactDetails[0].TRANS_CONT_NAME}</div>
        <div>Position: {contactDetails[0].TRANS_CONT_POS}</div>
        <div>Phone: {formatPhone(contactDetails[0].TRANS_PHONE)}</div>
        <div style={{ overflow: "auto" }} >Email: {contactDetails[0].TRANS_CONT_EMAIL}</div>
      </ProfileBanner>
    </div>
  );
};

export default TransporterContact;
